/* eslint-disable no-unused-expressions */
import React from "react";
import {connect} from "react-redux";
import "./CreateControl.css";
import * as actionsKinds from "../../Redux/Actions/Kinds";
import * as actionsTypes from "../../Redux/Actions/Types";
import * as actionsModes from "../../Redux/Actions/Modes";
import * as actionsProg from "../../Redux/Actions/Programs";
import * as actionsProj from "../../Redux/Actions/Projects";
import * as actionsUser from "../../Redux/Actions/Users";
import * as actionsLists from "../../Redux/Actions/ControlLists";
import * as httpService from "../HttpService/HttpService";
import * as PropertyBucket from "../../Properties/Properties.js";
import {registerLocale} from "react-datepicker";
import pl from "date-fns/locale/pl";
import "react-datepicker/dist/react-datepicker.css";
import {UpdateControlDto} from "../Dtos/UpdateControlDto";
import {Waiter} from "../WaitingSign/Waiting";
import PopUp from "../PopUp/PopUp";
import {addHours, isURLContainString} from "../../Helpers/utils";
import {ControlForm} from "./ControlForm";
import {isWTrakcieRealizacji} from "../ControlStateHelper";
import {compareByCode} from '../../Helpers/utils';

class UpdateControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isWaiting: false,
      isAllDataFetched: false,
      controlList: undefined,
      project: undefined,
      dateFrom: undefined,
      dateTo: undefined,
      kinds: [],
      controllers: [],
      type: undefined,
      mode: undefined,
      loadedControlData: null,
      controlId: this.props.match.params.controlId,
      projectDisabled: true,
      isControlInProgress: false,
      isPossibleChangeRoute: false,
      controlNumber: null,
      postControlDocuments: false,
      remarks: ''
    };
    this.handleClosePopUp = this.handleClosePopUp.bind(this);
  }

  allDataIsFetched = () => {
    return this.props.users.isLoading === false &&
        this.props.kinds.isLoading === false &&
        this.props.types.isLoading === false &&
        this.props.modes.isLoading === false &&
        this.props.users.isLoading === false &&
        this.props.lists.isLoading === false;


  };

  componentDidMount() {
    // Legacy code, needs improvements
    const {
      fetchProgsData,
      fetchKindsData,
      fetchTypesData,
      fetchModesData,
      fetchUsersData,
      fetchListsData,
    } = this.props;

    fetchKindsData();
    fetchTypesData();
    fetchModesData();
    fetchProgsData();
    fetchUsersData();
    fetchListsData();

    this.isWaitingOnOff(true);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.allDataIsFetched() && this.state.isAllDataFetched === false) {
      this.setState({ isAllDataFetched: true });
    }

    if (
      this.props.match.params.controlId &&
      this.state.isAllDataFetched &&
      prevState.isAllDataFetched === false
    ) {
      let url = PropertyBucket.getControlViewById(this.state.controlId);
      this.controlResponse = httpService.getService(url, "GET");
      this.controlResponse
        .then((data) => {
          const kinds = [];
          let mode;
          let type;
          data.dictionaryEntries.forEach((value) => {
            if (value.dictNumber === 1) {
              type = value;
            }
            if (value.dictNumber === 2) {
              mode = value;
            }
            if (value.dictNumber === 3) {
              kinds.push(value);
            }
          });
          const controlList = [];
          controlList.push(data.questionList);

          let admUsers = this.props.users.users;

          admUsers.push(
            ...data.controllers
              .filter((controller) => {
                return !admUsers.some(
                  (admUser) =>
                    admUser.login === controller.login &&
                    admUser.firstName === controller.firstName &&
                    admUser.lastName === controller.lastName
                );
              })
              .map((controller) => {
                const administrationLogin = controller.administrationLogin;
                const suffix = administrationLogin ? ` - ${administrationLogin}` : '';
                return {
                  ...controller,
                  firstAndLastName: `${controller.firstName} ${controller.lastName}`,
                  name: controller.firstName,
                  customLabel: `${controller.firstName} ${controller.lastName}${suffix}`,
                };
              })
          );

          const controllers = data.controllers.map(controller => {
            const suffix = controller.administrationLogin ? ` - ${controller.administrationLogin}` : '';
            return {
              ...controller,
              firstAndLastName: `${controller.firstName} ${controller.lastName}`,
              name: controller.firstName,
              customLabel: `${controller.firstName} ${controller.lastName}${suffix}`,
            };
          });

          const teamLeaderFullname = data.teamLeader ? `${data.teamLeader.firstName} ${data.teamLeader.lastName}` : null;

          this.setState({
            isWaiting: false,
            dateFrom: addHours(new Date(data.dateFrom), 2),
            dateTo: addHours(new Date(data.dateTo), 2),
            project: [data.project],
            controlList,
            controllers: controllers,
            type,
            mode,
            kinds,
            projectDisabled: true,
            isControlInProgress: isWTrakcieRealizacji(data),
            teamLeader: data.teamLeader ? { ...data.teamLeader, firstAndLastName: teamLeaderFullname } : null,
            controlNumber: data.number,
            postControlDocuments: data.postControlDocuments?.length > 0,
            remarks: data.remarks
          });

          document.title = `e-Kontrole | Edytuj kontrolę, projekt: ${data.project.number}`;
        })
        .catch((error) => {
          this.setState({
            showPopup: true,
            popUp: {
              title: "Błąd",
              notification: error.message,
              type: "error",
              onClose: () => {
                this.handleClosePopUp();
              },
            },
            isWaiting: false,
          });
        });
    }
  };

  getProjects(searchText) {
		this.props.fetchProjData(searchText);
	}

  isWaitingOnOff = (OnOff) => {
    this.setState({
      isWaiting: OnOff,
    });
  };

  handleClosePopUp() {
    this.setState({ showPopup: false, isAsync: false });
  }

  cancelSave = () => {
    this.setState({
      showPopup: true,
      popUp: {
        title: "Ostrzeżenie",
        notification: PropertyBucket.getCancelMessage(),
        type: "confirm",
        onClick: () => this.props.history.goBack(),
      },
    });
  };

  confirmChangeControlList = () => {
    return new Promise((resolve, reject) => {
      this.setState({
        showPopup: true,
        popUp: {
          title: "Ostrzeżenie",
          notification: PropertyBucket.getChangeControlListMessage(),
          type: "confirm",
          confirmText: "ZATWIERDŹ",
          cancelText: "ANULUJ",
          onClick: () => {
            resolve(true);
            this.handleClosePopUp();
          },
          onClose: () => {
            reject();
            this.handleClosePopUp();
          },
          isAsync: true
        },
      });
    });
  };

  handleSaveControl = async (values) => {
    this.isWaitingOnOff(true);

    const controlDto = new UpdateControlDto();
    controlDto.controlKinds = values.kinds;
    controlDto.controlMode = values.mode;
    controlDto.controlType = values.type;
    controlDto.dateFrom = values.dateFrom;
    controlDto.dateTo = values.dateTo;
    controlDto.controllers = values.controllers;
    controlDto.questionListId = values.controlList[0].listId;
    controlDto.teamLeader = this.isTeamLeaderSet(values.teamLeader) ? values.teamLeader : null;
    controlDto.remarks = values.remarks;

    if (this.state.controlList[0].listId !== controlDto.questionListId) {
      try {
        await this.confirmChangeControlList();
      } catch {
        this.isWaitingOnOff(false);
        return;
      }
    }

    const url = PropertyBucket.getEditControl(this.state.controlId);

    try {
      await httpService.getServicePromise(url, "PUT", controlDto, true);

      this.setState({
        disabled: "disabled",
        isWaiting: false,
        showPopup: true,
        isPossibleChangeRoute: true,
        popUp: {
          title: "Komunikat",
          notification: PropertyBucket.createControlMessage(),
          onClick: () => {
            isURLContainString(this.props.history.location.pathname, [
              "create_control",
            ]) && this.props.history.push("/controls/planned");

            isURLContainString(this.props.history.location.pathname, [
              "edit_control",
            ]) && this.props.history.goBack();
          },
          onClose: () => {
            this.handleClosePopUp();
          },
        },
      });
    } catch (error) {
      const errorMessages = {
        409: `Aktualna lista sprawdzająca "${this.state.controlList[0].codeAndName}" jest edytowana przez innego użytkownika. Nie można zmienić listy sprawdzającej. Spróbuj ponownie później.`,
        422: `Dla kontroli o numerze "${this.state.controlNumber}" zostały już wygenerowane dokumnety pokontrolne. Nie można zmienić listy sprawdzającej.`
      }
      this.setState({
        showPopup: true,
        popUp: { title: "Błąd", notification: errorMessages[error.status] || httpService.errorMessageText(error.status), type: "error", onClose: () => { this.handleClosePopUp() }, },
      });

      this.isWaitingOnOff(false);
    }
  };

  isTeamLeaderSet = (teamLeader) => teamLeader != null &&
      teamLeader.login != null &&
      teamLeader.firstName != null &&
      teamLeader.lastName != null;

  renderUserName = (loadedUserData) => {
    for (let i = 0; i < loadedUserData.length; i++) {
      loadedUserData[i].userAllName = loadedUserData[i].userFirstName + " " + loadedUserData[i].userSurname;
    }
  };

  render() {
    registerLocale("pl", pl);
    let loadedUserData = this.props.users.users;
    this.renderUserName(loadedUserData);
    let popUp;
    this.state.showPopup
      ? (popUp = (
          <PopUp
            type={this.state.popUp.type}
            title={this.state.popUp.title}
            notification={this.state.popUp.notification}
            link={this.state.popUp.link}
            onClickEvent={this.state.popUp.onClick}
            closePopUp={this.state.popUp?.onClose}
            confirmText={this.state.popUp?.confirmText}
            cancelText={this.state.popUp?.cancelText}
            isAsync={this.state.popUp?.isAsync}
          />
        ))
      : null;

      const controllers = this.props.users.users.map((controller) => {
      return {
        ...controller,
        firstAndLastName: controller.name + " " + controller.lastName,
      };
    });


    return (
      <div id='control_create'>
        {popUp}
        <h2 className='mb-3'>Edytuj kontrolę</h2>

        <ControlForm
          projects={this.props.projects.projects || []}
          kinds={this.props.kinds.kinds || []}
          types={this.props.types.types || []}
          modes={this.props.modes.modes || []}
          controllers={controllers|| []}
          controlLists={this.props.controlList.controlList || []}
          handleSaveControl={this.handleSaveControl}
          handleAbort={this.cancelSave}
          handleFormStateChanged={this.handlePossibleChangeRoute}
          selectedProject={this.state.project}
          selectedKinds={this.state.kinds}
          selectedType={this.state.type}
          selectedMode={this.state.mode}
          selectedControlList={this.state.controlList}
          selectedDateTo={this.state.dateTo}
          selectedDateFrom={this.state.dateFrom}
          selectedControllers={this.state.controllers}
          projectDisabled={this.state.projectDisabled}
          isControlInProgress={this.state.isControlInProgress}
          getProjects={(search) => this.getProjects(search)}
          editControlSource={this.props.match.params.source}
          selectedTeamLeader={this.state.teamLeader}
          controlNumber={this.state.controlNumber}
          postControlDocuments={this.state.postControlDocuments}
          remarks={this.state.remarks}
          isWaiting={this.state.isWaiting}
        />

        <div id='waiter'>
          <Waiter loading={this.state.isWaiting} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    users: {
      ...state.users,
      users: state.users.users ? state.users.users.map((user) => {
        return {
          ...user,
          firstName: user.name,
          firstAndLastName: `${user.name} ${user.lastName}`,
          customLabel: `${user.name} ${user.lastName} - ${user.administrationLogin}`,
        };
      }) : [],
    },
    controlList: {
      ...state.controlList,
      controlList: state.controlList.controlList.map((cl) => {
        return {
          ...cl,
          codeAndName: `${cl.code} - ${cl.name}`,
        };
      }).sort(compareByCode)
    }
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProgsData: () => dispatch(actionsProg.getProgramsData()),
    fetchProjData: (searchText) => dispatch(actionsProj.getProjectsData(searchText)),
    fetchUsersData: () => dispatch(actionsUser.getControllersUsersData()),
    fetchListsData: () => dispatch(actionsLists.getActiveListData()),
    fetchKindsData: () => dispatch(actionsKinds.getKindsData()),
    fetchTypesData: () => dispatch(actionsTypes.getTypesData()),
    fetchModesData: () => dispatch(actionsModes.getModesData()),
  };
};

export const UpdateControlProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateControl);
